import { PAGE_LOADED, PAGE_LOADING } from '../actions/page_loading';

const initialReceipt = {
  loading: false,
};

const pageReducer = (state = initialReceipt, action) => {
  switch (action.type) {
    case PAGE_LOADED:
      return {
        ...state,
        loading: false,
      };
    case PAGE_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default pageReducer;
